import { Box, Divider, HStack, Skeleton, useMediaQuery, VStack } from 'native-base';
import React, { memo } from 'react';
const StatusTrackerSkeleton = _ref => {
  let {
    dataTestID
  } = _ref;
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 768
  });
  return /*#__PURE__*/React.createElement(Box, {
    testID: dataTestID,
    borderColor: "gray.200",
    borderLeftWidth: 8,
    borderWidth: 1,
    borderRadius: "md",
    p: "4",
    flex: {
      lg: 2
    },
    maxH: "32"
  }, isSmallScreen ? /*#__PURE__*/React.createElement(VStack, {
    space: "4"
  }, /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 1,
    maxW: "24"
  }), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    h: "16",
    w: "16",
    rounded: "full"
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 1,
    maxW: "65%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    h: "4",
    w: "4",
    rounded: "full"
  }))) : /*#__PURE__*/React.createElement(VStack, {
    space: "6"
  }, /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 1,
    maxW: "24"
  }), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Divider, {
    position: "absolute",
    top: 6
  }), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between"
  }, [0, 1, 2, 3, 4].map(status => {
    return /*#__PURE__*/React.createElement(VStack, {
      space: "2",
      justifyContent: "center",
      key: status
    }, /*#__PURE__*/React.createElement(Skeleton, {
      h: "10",
      w: "10",
      rounded: "full"
    }), /*#__PURE__*/React.createElement(Skeleton.Text, {
      lines: 1
    }));
  })))));
};
export default /*#__PURE__*/memo(StatusTrackerSkeleton);
//# sourceMappingURL=index.js.map